// How a message to an agent session is sent. Words alone are the AgentRun's
// `say` action, so the offline queue and undo are what they always were.
// Pictures cannot ride an op or the mirror (no base64 in the changelog), so a
// message that carries any goes to the factory through POST
// /api/factory/runs/{name}/messages, online only; the picture shows once the
// factory echoes the line.

export interface RunOutgoing {
  text: string
  images: { media_type: string; data: string }[]
}

export type RunSendVia = 'say' | 'pictures'

export const runSendVia = (m: RunOutgoing): RunSendVia => (m.images.length > 0 ? 'pictures' : 'say')

/** The factory's rule for a picture's file name (internal/api/factory.go pictureFile). */
export const PICTURE_FILE = /^[0-9]+-[0-9]+\.(jpg|png|gif|webp)$/

/** Why a picture message did not go, in words for the composer; the draft stays. */
export const pictureSendError = (e: unknown, online: boolean): string =>
  !online ? 'You are offline. Pictures need a connection.' : (e as Error).message || 'Not sent'
